import { Payload }         from 'Models/UI/Payload';
import { BusinessPartner } from 'Workflow/Steps/Participants/Models/BusinessPartner';
import { Passenger }       from 'Workflow/Steps/Participants/Models/Passenger';

export class PayloadParticipants implements Payload {
    businessPartner : BusinessPartner;
    passengers : Passenger[];
}
